import type { ColumnSort } from '@plato/ui/components/data-table';
import React from 'react';
import type { QuoteOrderSort } from '../../../server/types/list-view-types.ts';
import {
    QuotesOrdersSortBy,
    quotesOrdersSortFields,
    SortOrder,
} from '../../../server/types/list-view-types.ts';
import { useGenericListViewSorting } from './use-generic-list-view-sorting.tsx';

type UseSortQuotesOrdersGridResult = {
    sorting: ColumnSort<QuotesOrdersSortBy> | undefined;
    setSorting: (sort: ColumnSort | undefined) => void;
    sortingFilter: QuoteOrderSort | null;
};

// MARK - TO REMOVE. Not used anymore except the tables on home dashboard which is going to be removed ASAP
export function useSortQuotesOrdersGrid(): UseSortQuotesOrdersGridResult {
    const [sortingFilter, setSortingFilter] = React.useState<QuoteOrderSort | null>({
        field: QuotesOrdersSortBy.ORDER_CREATED_AT_DATE,
        direction: SortOrder.DESC,
    });

    const [sorting, setSorting] = useGenericListViewSorting<QuotesOrdersSortBy>(
        sortingFilter,
        (next) => {
            setSortingFilter(next ?? null);
        },
        quotesOrdersSortFields,
    );

    return {
        sorting,
        setSorting,
        sortingFilter,
    };
}
